import styled from 'styled-components';
import { StatusTicketProps } from '../../common/interfaces';
import { TypeTicketStatusColor } from '../../components/enum/typeTicketStatusEnum';

export {
    Container,
    Title,
    TableContainer,
    Pagination,
    ActionButton,
    Table,
    SearchCard as ProductSearchCard,
} from '../sharedTable.styled';

export const StatusCell = styled.td<StatusTicketProps>`
  color: ${({ status }) => TypeTicketStatusColor[status] || 'var(--text)'};
  font-weight: 700;
`;
